(function () {
  var overlay, panel, input, body, closeBtn, backdrop, trigger;
  var debounceTimer = null;
  var currentController = null;
  var lastQuery = '';

  function formatPrice(price) {
    if (price === null || price === undefined || price === '') return '';
    return '$' + price;
  }

  function escapeHtml(str) {
    return (str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function open() {
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    overlay.setAttribute('aria-hidden', 'false');
    setTimeout(function () { input.focus(); }, 50);
  }

  function close() {
    overlay.classList.remove('open');
    document.body.style.overflow = '';
    overlay.setAttribute('aria-hidden', 'true');
  }

  function renderEmpty() {
    body.innerHTML = '<div class="fh-search-empty">Start typing to search products, collections &amp; more</div>';
  }

  function renderLoading() {
    body.innerHTML = '<div class="fh-search-loading"><span class="fh-search-spinner"></span></div>';
  }

  function renderNoResults(query) {
    body.innerHTML =
      '<div class="fh-search-empty">No results for &ldquo;' + escapeHtml(query) + '&rdquo;</div>' +
      '<a class="fh-search-viewall" href="' + window.fhRoutes.search + '?q=' + encodeURIComponent(query) + '">View all results</a>';
  }

  function renderResults(query, data) {
    var resources = data.resources && data.resources.results ? data.resources.results : {};
    var products = resources.products || [];
    var collections = resources.collections || [];
    var queries = resources.queries || [];

    if (!products.length && !collections.length) {
      renderNoResults(query);
      return;
    }

    var html = '';

    if (queries.length) {
      html += '<div class="fh-search-results">';
      queries.slice(0, 4).forEach(function (q) {
        var label = q.styled_text ? q.styled_text : escapeHtml(q.text);
        html +=
          '<a class="fh-search-query-link" href="' + q.url + '">' +
            '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="11" cy="11" r="7.5"/><path d="m20.5 20.5-4.5-4.5"/></svg>' +
            '<span class="fh-search-query-text">' + label + '</span>' +
          '</a>';
      });
      html += '</div>';
    }

    if (collections.length) {
      html += '<div class="fh-search-section-label">Collections</div><div class="fh-search-results">';
      collections.slice(0, 3).forEach(function (c) {
        html +=
          '<a class="fh-search-result fh-search-result--text-only" href="' + c.url + '">' +
            '<div class="fh-search-result-info"><div class="fh-search-result-title">' + escapeHtml(c.title) + '</div></div>' +
          '</a>';
      });
      html += '</div>';
    }

    if (products.length) {
      html += '<div class="fh-search-section-label">Products</div><div class="fh-search-results">';
      products.slice(0, 6).forEach(function (p) {
        var img = p.image || '';
        var price = p.price_varies ? ('From ' + formatPrice(p.price_min)) : formatPrice(p.price);
        html +=
          '<a class="fh-search-result" href="' + p.url + '">' +
            '<div class="fh-search-result-img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
            '<div class="fh-search-result-info">' +
              '<div class="fh-search-result-title">' + escapeHtml(p.title) + '</div>' +
              (price ? '<div class="fh-search-result-price">' + price + '</div>' : '') +
            '</div>' +
          '</a>';
      });
      html += '</div>';
    }

    html += '<a class="fh-search-viewall" href="' + window.fhRoutes.search + '?q=' + encodeURIComponent(query) + '">View all results for &ldquo;' + escapeHtml(query) + '&rdquo;</a>';

    body.innerHTML = html;
  }

  function fetchResults(query) {
    if (currentController) currentController.abort();
    currentController = new AbortController();

    var url = window.fhRoutes.predictiveSearch +
      '?q=' + encodeURIComponent(query) +
      '&resources[type]=product,collection,query' +
      '&resources[limit]=6' +
      '&resources[options][unavailable_products]=last';

    fetch(url, { signal: currentController.signal, headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (query !== lastQuery) return;
        renderResults(query, data);
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        renderNoResults(query);
      });
  }

  function onInput(e) {
    var query = e.target.value.trim();
    lastQuery = query;
    clearTimeout(debounceTimer);

    if (!query) {
      renderEmpty();
      return;
    }

    renderLoading();
    debounceTimer = setTimeout(function () { fetchResults(query); }, 220);
  }

  document.addEventListener('DOMContentLoaded', function () {
    overlay = document.getElementById('fh-search-overlay');
    if (!overlay) return;
    panel = overlay.querySelector('.fh-search-panel');
    input = document.getElementById('fh-search-input');
    body = document.getElementById('fh-search-body');
    closeBtn = document.getElementById('fh-search-close');
    backdrop = overlay.querySelector('.fh-search-backdrop');
    trigger = document.querySelectorAll('[data-fh-search-trigger]');

    trigger.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', close);
    panel.addEventListener('click', function (e) { e.stopPropagation(); });

    input.addEventListener('input', onInput);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        var query = input.value.trim();
        if (query) window.location.href = window.fhRoutes.search + '?q=' + encodeURIComponent(query);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('open')) close();
    });

    renderEmpty();
  });
})();
